import { Component, effect, inject, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/angular/standalone';
import {
  EFreightForShipperStatus,
  getEmptyFreightBasicForShipper,
  getEmptyFreightDetailForShipper,
  IFreightBasicForShipper,
  IFreightDetailedForShipper,
  transformToIFreightBasicFromIFreightDetailForShipper,
} from '@okcargo-apps/shared-domain';
import { FreightDocumentationLinksComponent } from '../../freight-documentation/freight-documentation-links/freight-documentation-links.component';
import { IncidenceButtonComponent } from '../../incidence-button/incidence-button.component';
import { FreightShipperService } from '../freight-shipper.service';
import { PriceAcceptanceButtonsComponent } from '../price-acceptance-buttons/price-acceptance-buttons.component';

@Component({
  selector: 'lib-freight-shipper-detail-footer-buttons',
  templateUrl: './freight-shipper-detail-footer-buttons.component.html',
  styleUrls: ['./freight-shipper-detail-footer-buttons.component.scss'],
  imports: [
    IonButton,
    IonCol,
    IonRow,
    IonGrid,
    RouterLink,
    RouterLinkActive,
    IncidenceButtonComponent,
    FreightDocumentationLinksComponent,
    PriceAcceptanceButtonsComponent,
  ],
})
export class FreightShipperDetailFooterButtonsComponent {
  private readonly freightShipService = inject(FreightShipperService);

  @Input()
  id!: string;

  public freight: IFreightDetailedForShipper = getEmptyFreightDetailForShipper();
  public freightBasic: IFreightBasicForShipper = getEmptyFreightBasicForShipper();

  public EFreightStatus = EFreightForShipperStatus;

  constructor() {
    effect(() => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      this.freightShipService.lastRefreshFreightShipDetailTimestamp;
      this.loadFreightDetail();
    });
  }

  public loadFreightDetail(): void {
    this.freightShipService.findFreightShipDetail$(this.id).subscribe((freight) => {
      this.freight = freight;
      this.freightBasic = transformToIFreightBasicFromIFreightDetailForShipper(freight);
      // TODO check if mapper works well
    });
  }

  get isEditable(): boolean {
    return [
      EFreightForShipperStatus.OFFER_REQUESTED,
      EFreightForShipperStatus.OFFER_SENT,
      // EFreightStatus.DELETED,
      // EFreightStatus.CANCELLED,
    ].includes(this.freightBasic.status);
  }

  get isDocumentationDownloadable(): boolean {
    return [
      EFreightForShipperStatus.ASSIGNED,
      EFreightForShipperStatus.ON_ROUTE,
      EFreightForShipperStatus.FINISHED,
      EFreightForShipperStatus.DELETED,
      EFreightForShipperStatus.CANCELLED,
    ].includes(this.freightBasic.status);
  }

  get isPendingAcceptance(): boolean {
    return [EFreightForShipperStatus.OFFER_SENT].includes(this.freightBasic.status);
  }
}
